import { useColumnsAgendamientos } from "@/erp/operaciones/agendamiento/shared/hooks";
import EditAgendamientoImagen from "@/erp/sale/asesor/agendamiento/shared/componente/edit_agendamiento_imagen/EditAgendamientoImage";
import {
  EstadosContratoChoiceEnum,
  ROUTER_PATHS,
  TABLE_CONSTANTS_COLUMS,
} from "@/shared";
import { useFetchAgendamientos } from "@/shared/actions/erp";
import { GeneralTable } from "@/shared/components/ui";
import {
  useLoaders,
  useTableFilter,
  useTableServerSideFiltering,
} from "@/shared/hooks";
import { Agendamiento, IDataPreventa } from "@/shared/interfaces";
import { useUiStore } from "@/store/ui";
import { Grid, IconButton, Tooltip } from "@mui/material";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { RiImageEditFill } from "react-icons/ri";
import { useNavigate } from "react-router-dom";

interface AgendamientoAgendadoPageProps {
  estado_agendamiento: string;
  estado_contrato?: EstadosContratoChoiceEnum;
}

export default function AgendamientoAgendadoTable({
  estado_agendamiento,
  estado_contrato,
}: AgendamientoAgendadoPageProps) {
  const clientesFibraOReturnUrl = ROUTER_PATHS.clientes.clienteContratoNav;
  const setConfirmDialog = useUiStore((s) => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiStore((s) => s.setConfirmDialogIsOpen);
  const navigate = useNavigate();
  const [modalEditImagen, setModalEditImagen] = useState(false);
  // PERF: useForm<IDataPreventa (139 props) & {…}> hacía explotar Path<T> en el tsc. Tipo plano; runtime igual.
  const formEditImagen = useForm<Record<string, any> & { id_agendamiento: string }>();

  const { agendamientoColumnaVentas } = useColumnsAgendamientos();
  const { pagination, dateBefore, dateAfter, setPagination } = useTableFilter();

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const { pageIndex, pageSize } = pagination;

  ///* React Query

  const {
    isLoading,
    data: agendaRes,
    isRefetching,
  } = useFetchAgendamientos({
    enabled: true,
    params: {
      estado_agendamiento_in: estado_agendamiento,
      page: pageIndex + 1,
      page_size: pageSize,
      fecha_creacion_after: dateAfter,
      fecha_creacion_before: dateBefore,
      ...filterObject,
      filterByState: false,
      contrato_estado_contrato: estado_contrato ?? undefined,
    },
  });

  useLoaders(isLoading || isRefetching);

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <GeneralTable<Agendamiento>
            columns={agendamientoColumnaVentas}
            data={agendaRes?.data.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            // // search
            enableGlobalFilter={false}
            // onGlobalFilterChange={setGlobalFilter}
            // // pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={agendaRes?.data?.count}
            // // actions
            actionsColumnSize={TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM}
            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            enableSorting={false}
            // crud
            positionActionsColumn="first"
            enableColumnActions={true}
            canEdit={false}
            showCustomActionBtnSpace={true}
            customActionBtnSpace={(row) => {
              return (
                <Grid container spacing={0}>
                  <Grid item>
                    <Tooltip title={"Editar imagen"} placement="top">
                      <IconButton
                        color="info"
                        onClick={() => {
                          if (
                            row.contrato_data != null &&
                            row.contrato_data.estado_actualizacion ===
                              EstadosContratoChoiceEnum.SOLICITUD_CORRECCION
                          ) {
                            setConfirmDialogIsOpen(true);
                            setConfirmDialog({
                              cancelTextBtn: "Salir",
                              isOpen: true,
                              title: "¡Solicitud de correción!",
                              subtitle:
                                "No puedes realizar actualizaciones mientras tengas una solicitud de corrección emitida por el área de contratos. ¿Cambiar a pendiente de actualizar?",
                              onClose() {
                                setConfirmDialogIsOpen(false);
                              },
                              async onConfirm() {
                                navigate(
                                  `${clientesFibraOReturnUrl}/actualizar/${row.contrato_data.id_contrato}`
                                );
                                setConfirmDialogIsOpen(false);
                              },
                            });
                            return;
                          }

                          setModalEditImagen(true);
                          const {
                            preventa_data,
                            forma_pago_data,
                            id_agendamiento,
                          } = row;

                          formEditImagen.reset({
                            ...preventa_data,
                            id_agendamiento: id_agendamiento,
                            codigo_forma_pago: forma_pago_data.forma_pago,
                          });
                        }}
                      >
                        <RiImageEditFill />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                </Grid>
              );
            }}
          />
        </Grid>
      </Grid>
      {modalEditImagen && (
        <EditAgendamientoImagen
          open={modalEditImagen}
          setOpen={setModalEditImagen}
          form={formEditImagen as any}
        />
      )}
    </>
  );
}
